import React from 'react';

const FrontDescription = () =>
  (<section className="front-description">
    <div className="container">
      <div className="row">
        <div className="col-lg-5">
          <div className="front-description__title">
            <h2>ETL Filter, Raitz & Kollegen
              Steuerberatungsgesellschaft</h2>
          </div>
        </div>
        <div className="front-description__text col-lg-6">
          <p><strong>Kompetent, motiviert, flexibel, zuverlässig.</strong></p>
          <p>Wir betreuen mit zwei Steuerberatern, zwei Wirtschaftsprüferinnen / Steuerberaterinnen und einem Team von hochqualifizierten Mitarbeitern im ganzen Bundesgebiet mittelständische Unternehmen aus allen Branchen und Rechtsformen, sowie Privatpersonen.</p>
          <p>Die Kombination aus erfahrenen und jungen Berufskollegen mit unterschiedlichen Ausbildungsschwerpunkten (Universität, Finanzverwaltung) gehört zu unseren Stärken.</p>
        </div>
      </div>
    </div>
  </section>);

export default FrontDescription;



// WEBPACK FOOTER //
// ./src/components/front-description/index.js